import type { OriginatingInstitutionsPageProps, PageProps } from "@/types";
import React, { FC } from "react";
import {
  OriginatingInstitutionsDelightCustomers,
  OriginatingInstitutionsHero,
  OriginatingInstitutionsModernizePayments,
} from "../originating-institutions";
import { Cta } from "../cta";
import { NextPage } from "../next-page";

export const OriginatingInstitutions: FC<
  PageProps<OriginatingInstitutionsPageProps>
> = (props) => {
  return (
    <div>
      <OriginatingInstitutionsHero
        label="Originating Institutions"
        title={props.data.title}
        description={props.data.description}
        cover={props.data.cover}
        cta={props.data.cta}
        contactModal={props.data.contactModal}
      />
      {/* TODO: Temporary hidden */}
      {/* <div className="wrapper wrapper_lg">
        <Cta
          cta={props.data.challengesCta}
          theme="light"
          className="originatingInstitutionsChallengesCta"
        />
      </div> */}
      <OriginatingInstitutionsDelightCustomers
        content={props.data.streamlineComplianceAndRiskManagement}
        cards={props.data.streamlineComplianceAndRiskManagementCards}
        cta={props.data.delightCustomersCta}
      />
      <OriginatingInstitutionsModernizePayments
        content={props.data.modernizePaymentsContent}
        cards={props.data.modernizePaymentsCards}
      />
      <OriginatingInstitutionsDelightCustomers
        content={props.data.delightCustomersContent}
        cards={props.data.delightCustomersCards}
        cta={props.data.delightCustomersCta}
      />
      <NextPage {...props.data.nextPage} />
    </div>
  );
};
